<template>
  <div>
    <b-modal id="countrySelect" class="modal-body"
             no-close-on-backdrop
             no-close-on-esc
             hide-footer
             hide-header-close
    >
        <div class="country-oval">
          &nbsp;
        </div>
        <div class="col-6 offset-3 col-md-4 offset-md-4 mt-5 text-center country-logo-container">
          <img src="@/assets/logos/logo-white@2x.png" alt="Ábaco Latam" title="Ábaco Latam" class="country-logo">
        </div>
        <div class="container" style="margin-top: 3rem !important;">
          <div class="row mb-4">
            <div class="col-12 text-white mb-md-2 text-center abaco-modal-header-text w-100">
              <span>¿En qué país estás?</span>
            </div>
          </div>
          <abaco-flag country_name="Colombia" country_flag_image="colombia" country_short_code="co"
                      @onSelectCountry="countrySelected">
          </abaco-flag>

          <abaco-flag country_name="México" country_flag_image="mexico" country_short_code="mx"
                      @onSelectCountry="countrySelected">
          </abaco-flag>

          <abaco-flag country_name="Perú" country_flag_image="peru" country_short_code="pe"
                      @onSelectCountry="countrySelected">
          </abaco-flag>
        </div>
      <div class="country-oval country-oval-bottom">
        &nbsp;
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import { AbacoFlag } from './AbacoFlag'
export default {
  name: 'ChooseCountry',
  methods: {
    countrySelected(value) {
      this.$emit('onSelectCountry', value)
    }
  }
}
</script>

<style>
.modal{
    display: block !important;
}
.modal-dialog{
      overflow-y: initial !important
}
.modal-body{
  height: 250px;
  overflow-y: auto;
}
.country-logo-container {
  margin-top: 7rem !important;
}
.country-logo {
  width: 50%;
}
.country-oval {
  background-color: #000000;
  opacity: 0.07;
  border-radius: 100%;
  width: 250px;
  height: 250px;
  position: absolute;
  left: -130px;
  top: -130px;
}
.country-oval-bottom {
  left: unset;
  top: unset;
  right: -90px;
  bottom: -90px;
  width: 200px;
  height: 200px;
}
.countrySelect {
  max-width: 95%;
}
.abaco-modal-header-text {
  height: 65px;
  width: 451px;
  color: #FFFFFF;
  font-family: "Source Serif Pro";
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 65px;
}
.modal {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}
.modal-dialog {
  max-width: 100% !important;
  max-height: 100% !important;
  margin: 0px;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-y: hidden;
}
.modal-content {
  height: auto;
  min-height: 100%;
  border-radius: 0;
}
.modal-header {
  display: none !important;
  padding: 0 !important;
}
.modal-body, .modal-footer {
  border: 0px;
  width: 100%;
  height: 100%;
  background-color: #00C087;
  padding: 0px;
}
@media (max-width: 756px) {
  .country-logo {
    width: 100%;
  }
  .abaco-modal-header-text {
    font-size: 2.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChooseCountry.vue